import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export default LanguageContext;

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('english');
    
    const toggleLanguage = () => {
        setLanguage(language === 'english' ? 'persian' : 'english');
    };

    const setLanguageTo = (lang) => {
        setLanguage(lang);
    };

    const contextData = {
        language,
        toggleLanguage,
        setLanguageTo
    };

    return (
        <LanguageContext.Provider value={contextData}>
            {children}
        </LanguageContext.Provider>
    );
}; 